export const ORIGINAL_ESTIMATE_INLINE_READ_EDIT_VIEW_BADGE =
	'issue-field-original-estimate-inline-edit-readview.ui.badge';
export const ORIGINAL_ESTIMATE_INLINE_EDIT_READ_VIEW_WRAPPER =
	'issue-field-original-estimate-inline-edit-readview.ui.wrapper';
